import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/image/video1.mp4'
import _imports_1 from '../assets/image/video2.mp4'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-top-img" }
const _hoisted_3 = { class: "product-content" }
const _hoisted_4 = { class: "home-col-title" }
const _hoisted_5 = { class: "home-col-desc" }
const _hoisted_6 = { class: "home-col-desc" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "home-col-desc" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "home-col-desc" }
const _hoisted_12 = { class: "home-col-desc" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "home-col-desc" }
const _hoisted_15 = { class: "home-col-desc" }
const _hoisted_16 = { class: "home-content" }
const _hoisted_17 = { class: "home-content-box" }
const _hoisted_18 = { class: "home-content-title" }
const _hoisted_19 = { class: "home-content-desc" }
const _hoisted_20 = ["poster"]
const _hoisted_21 = ["poster"]
const _hoisted_22 = { class: "home-bottom-box" }
const _hoisted_23 = { class: "home-bottom-box-mengban" }
const _hoisted_24 = { class: "home-bottom-box-mengban-title" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "en" }

import commonHead from '@/components/commonHeader.vue'
import commonFooter from '@/components/commonFooter.vue'
import WaterfallGallery from '@/components/waterfallGallery.vue'
import homeSrc from '@/assets/image/c1.webp';
import banner1 from '@/assets/image/home/banner1.webp';
import banner2 from '@/assets/image/home/banner2.webp';
import banner3 from '@/assets/image/home/banner3.webp';
import banner4 from '@/assets/image/home/banner4.webp';
import c1 from '@/assets/image/home/h3.webp';
import c2 from '@/assets/image/home/h1.webp';
import c3 from '@/assets/image/home/h4.webp';
import h1 from '@/assets/image/home/h2.webp';

import productSrc from '@/assets/image/c1.webp';
import productSrc1 from '@/assets/image/c1.webp';
import productSrc2 from '@/assets/image/c2.webp';
import productSrc3 from '@/assets/image/c3.webp';
import productSrc4 from '@/assets/image/h1.webp';
import video1 from '@/assets/image/video1.mp4';
import video1Png from '@/assets/image/home/video1.webp';
import video2Png from '@/assets/image/home/video2.webp';
import video2 from '@/assets/image/video2.mp4';

import p1 from '@/assets/image/home/1.webp';
import p2 from '@/assets/image/home/2.webp';
import p3 from '@/assets/image/home/3.webp';
import p4 from '@/assets/image/home/banner1.webp';
import p5 from '@/assets/image/home/5.webp';
import p6 from '@/assets/image/home/6.webp';
import p7 from '@/assets/image/home/7.webp';
import p8 from '@/assets/image/home/banner2.webp';
import p9 from '@/assets/image/home/9.webp';
import p10 from '@/assets/image/home/10.webp';
import p11 from '@/assets/image/home/11.webp';
import p12 from '@/assets/image/home/banner3.webp';
import p13 from '@/assets/image/home/13.webp';
import p14 from '@/assets/image/home/14.webp';
import p15 from '@/assets/image/home/15.webp';
import p16 from '@/assets/image/home/banner4.webp';
import p17 from '@/assets/image/home/17.webp';
import p18 from '@/assets/image/home/18.webp';
import p19 from '@/assets/image/home/19.webp';
import p20 from '@/assets/image/home/20.webp';
import p21 from '@/assets/image/home/21.webp';
import p22 from '@/assets/image/home/22.webp';
import p23 from '@/assets/image/home/23.webp';
import p24 from '@/assets/image/home/24.webp';
import p25 from '@/assets/image/home/25.webp';



import { ref,onMounted } from 'vue';
import { useRouter } from 'vue-router';  // import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
const parentData = '0';// 传递给父组件的数据

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();
const router = useRouter();

store.commit('setNavIndex',0)

const gotoHhb = () =>{
  router.push('/hhb')
}

const gotoBreeze = (value: any) =>{
  router.push({path:'/breeze',query:{name:value}})
}

const handleLoadMore = () => {
  console.log('load more');
}
const handleImageClick = (item:any) => {
  console.log('image click',item);
}


const imageList = ref([
  { image: p1, alt: 'Image 1' },
  { image: p2, alt: 'Image 2' },
  { image: p3, alt: 'Image 3' },
  { image: p4, alt: 'Image 4' },
  { image: p5, alt: 'Image 5' },
  { image: p6, alt: 'Image 5' },
  { image: p7, alt: 'Image 5' },
  { image: p8, alt: 'Image 5' },
  { image: p9, alt: 'Image 5' },
  { image: p10, alt: 'Image 5' },
  { image: p11, alt: 'Image 5' },
  { image: p12, alt: 'Image 5' },
  { image: p13, alt: 'Image 5' },
  { image: p14, alt: 'Image 5' },
  { image: p15, alt: 'Image 5' },
  { image: p16, alt: 'Image 5' },
  { image: p17, alt: 'Image 5' },
  { image: p18, alt: 'Image 5' },
  { image: p19, alt: 'Image 5' },
  { image: p20, alt: 'Image 5' },
  { image: p21, alt: 'Image 5' },
  { image: p22, alt: 'Image 5' },
  { image: p23, alt: 'Image 5' },
  { image: p24, alt: 'Image 5' },
  { image: p25, alt: 'Image 5' }
  ])
// this.$store.commit('setNavIndex', 1);
// console.log('HomeView loaded',this.$store.state.navIndex);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(commonHead, { data: parentData }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, {
        height: "1000px",
        class: "banners",
        trigger: "click",
        arrow: "never"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
            return _createVNode(_component_el_carousel_item, { key: item }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "banners-img",
                  src: item === 1 ? _unref(banner1) : item === 2 ? _unref(banner2) : item === 3 ? _unref(banner3) : _unref(banner4),
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, {
        class: "home-row",
        gutter: 30
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            class: "home-col",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "home-col-boxs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 2 }),
                  _createVNode(_component_el_col, {
                    class: "home-col-box",
                    span: 10
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('home.hhb_title')), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('home.hhb_desc1')), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('home.hhb_desc2')), 1),
                      _createVNode(_component_el_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoHhb())),
                        class: "home-button",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.more')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "product-col2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        class: "product-img",
                        src: _unref(h1)
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "home-col",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "home-col-boxs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 2 }),
                  _createVNode(_component_el_col, {
                    class: "home-col-box",
                    span: 10
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "home-col-title",
                        innerHTML: _ctx.$t('home.breeze1_title')
                      }, null, 8, _hoisted_7),
                      _createElementVNode("div", {
                        class: "home-col-desc",
                        innerHTML: _ctx.$t('home.breeze1_desc1')
                      }, null, 8, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('home.breeze1_desc2')), 1),
                      _createVNode(_component_el_button, {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoBreeze('one'))),
                        class: "home-button",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.more')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "product-col2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        class: "product-img",
                        src: _unref(c1)
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "home-col",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "home-col-boxs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 2 }),
                  _createVNode(_component_el_col, {
                    class: "home-col-box",
                    span: 10
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "home-col-title",
                        innerHTML: _ctx.$t('home.breeze2_title')
                      }, null, 8, _hoisted_10),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('home.breeze2_desc1')), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('home.breeze2_desc2')), 1),
                      _createVNode(_component_el_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoBreeze('two'))),
                        class: "home-button",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.more')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "product-col2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        class: "product-img",
                        src: _unref(c2)
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            class: "home-col",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, { class: "home-col-boxs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 2 }),
                  _createVNode(_component_el_col, {
                    class: "home-col-box",
                    span: 10
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "home-col-title",
                        innerHTML: _ctx.$t('home.breeze3_title')
                      }, null, 8, _hoisted_13),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('home.breeze3_desc1')), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('home.breeze3_desc2')), 1),
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (gotoBreeze('three'))),
                        class: "home-button",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.more')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "product-col2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        class: "product-img",
                        src: _unref(c3)
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('home.content_title')), 1),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.content_desc[0]')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.content_desc[1]')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.content_desc[2]')), 1)
        ])
      ]),
      _createVNode(_component_el_row, {
        class: "home-content-bottom",
        gutter: 40
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("video", {
                class: "home-content-bottom-img home-content-bottom-img1",
                poster: _unref(video1Png),
                src: _imports_0,
                controls: ""
              }, null, 8, _hoisted_20)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("video", {
                class: "home-content-bottom-img",
                poster: _unref(video2Png),
                src: _imports_1,
                controls: ""
              }, null, 8, _hoisted_21)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('home.bottom_title')), 1),
          _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('home.bottom_en')), 1)
        ])
      ]),
      _createVNode(WaterfallGallery, {
        images: imageList.value,
        columnCount: 3,
        columnGap: 15,
        onLoadmore: handleLoadMore,
        onItemClick: handleImageClick
      }, null, 8, ["images"])
    ]),
    _createVNode(commonFooter)
  ]))
}
}

})